"use client";
import React, { useState } from "react";
import { Accordion, FlexCol } from "../ui";
import CoreServicesSectionHeader from "../coreServicesSectionHeader";
import { cn } from "@/lib";
import { IFaqCategory } from "@/interfaces";

const FaqInformationSection = ({
  selectedCategory,
}: {
  selectedCategory: IFaqCategory;
}) => {
  const [openAccordionId, setOpenAccordionId] = useState<string | null>(null);
  const { label, description, faqContent } = selectedCategory;
  return (
    <FlexCol
      gap={2}
      className="mx-auto w-full max-w-[700px] lg:max-w-[900px] xl:max-w-full"
    >
      <CoreServicesSectionHeader
        className="max-w-full px-0 text-right"
        title={label}
        description={description}
        titleClassName="text-black text-xl"
        descriptionClassName="text-custom-gray-200"
      />
      <FlexCol className={cn("mx-auto w-full max-w-[1100px] xl:gap-2")}>
        {faqContent.map((faq) => (
          <Accordion
            key={faq.id}
            title={faq.title}
            open={faq.id === openAccordionId}
            onOpenChange={(isOpen) => {
              setOpenAccordionId(isOpen ? faq.id : null);
            }}
          >
            {Array.isArray(faq.content) ? (
              <ul className="p-4 pt-2">
                {faq.content.map((item, idx) => (
                  <li key={idx}>{item}</li>
                ))}
              </ul>
            ) : (
              <p className="p-4 pt-2">{faq.content}</p>
            )}
          </Accordion>
        ))}
      </FlexCol>
    </FlexCol>
  );
};

export default FaqInformationSection;
